import { getResponseParseService } from 'services/ResponseParseService'
import { makeInitRequest } from 'services/ServerService'
import { signal } from 'services/SignalsService'
import { Device } from 'utils/Device'

const name = 'REQUEST-INIT'

async function execute() {

  const deviceModel = Device.getDeviceModel()

  const response = await makeInitRequest({
    token: game.models.GameModel.token,
    platform: game.models.GameModel.platform,
    m: game.models.GameModel.m,
    device: {
      model: `${deviceModel.vendor} ${deviceModel.model}`,
      vendor: deviceModel.vendor || 'none',
      browser: deviceModel.browser || 'none',
    },
  })

  if(response && response.user){
    game.models.UserModel.set(response.user)
    getResponseParseService().parse(response)
  }
  else {
    return signal.promise('REQUEST-INIT-DONE')
  }

}

export function getRequestInitAction() {
  return {
    name,
    execute,
  }
}
